import { IconButton, Tooltip } from '@chakra-ui/react';
import { ReactComponent as DuplicateIcon } from 'assets/icons/duplicate.svg';
import { duplicateActiveWidgets } from 'modules/Editor/Editor.helpers';
import { useAppSelector } from 'modules/Editor/store';
import { selectHasActiveWidget } from 'modules/Editor/store/widgetSelector';
import { Keyboard } from 'modules/common/components/Keyboard';
import { useTranslation } from 'react-i18next';

export const DuplicateMenu = () => {
  const { t } = useTranslation('editor_toolbar', { useSuspense: false });
  const isDisabled = !useAppSelector(selectHasActiveWidget);
  const label = t('duplicate');

  const onDuplicate = () => {
    duplicateActiveWidgets();
  };

  return (
    <Tooltip
      hasArrow
      placement='bottom'
      label={
        <>
          {label} <Keyboard shortcut={['ctrl', 'D']} macOs={['⌘', 'D']} />
        </>
      }
      bg='black'
    >
      <IconButton
        isDisabled={isDisabled}
        size='sm'
        variant={'ghost-with-active'}
        aria-label={label}
        icon={<DuplicateIcon />}
        onClick={onDuplicate}
      />
    </Tooltip>
  );
};
